module.exports = __webpack_public_path__ + "statics/img/cate10-2@2x.6e1b9489.png";